// extracted by mini-css-extract-plugin
export default {"mail-renderer-iframe":"components-parity-parity-manager-mail-template-renderer-module__mail-renderer-iframe"};